import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const TogglePhotoFlaggedApi = {
  togglePhotoFlagged: async (p_id) => {
    try {
      const response = await axiosInstance.post(Configs.togglePhotoFlaggedEp, {
        p_id: p_id,
      });

      if (response.status === 200) {
        return response.data; // Assuming the endpoint returns { p_id: ..., p_flagged: ... }
      } else {
        throw new Error("Failed to toggle photo flag");
      }
    } catch (error) {
      console.error("Error toggling photo flag:", error);
      return null;
    }
  },
};

export default TogglePhotoFlaggedApi;
